/**
 *  ButtonManager
 *
 *  Created by legman on 15/08/2017.
 *
 */

/**
 * @class
 * @namespace P3
 */
export default class ButtonManager {
    /**
     * @param {P3.Input} input
     */
    constructor(input) {
        /**
         * @member {P3.Input}
         * @private
         */
        this._input = input;

        /**
         * @member {Array.<P3.Button>}
         * @private
         */
        this._buttons = [];

        /**
         * @member {P3.Button}
         * @private
         */
        this._currentFocus = null;

        // todo finish this class at some point
    }

    /**
     * @param {P3.Button} button
     */
    add(button) {
        if (this._buttons.indexOf(button) !== -1) return;
        this._buttons.push(button);
    }

    /**
     * @param button
     */
    remove(button) {
        const i = this._buttons.indexOf(button);
        this._buttons.splice(i, 1);
    }

    update() {
        if (this._input.isKeyPressed(37)) {
            this._selectLeft();
        }
        if (this._input.isKeyPressed(39)) {
            this._selectRight();
        }
        if (this._input.isKeyPressed(38)) {
            this._selectUp();
        }
        if (this._input.isKeyPressed(40)) {
            this._selectDown();
        }
    }

    /**
     * @param {P3.Button} button
     */
    focus(button) {
        for (let i = 0; i < this._buttons.length; ++ i) {
            const button = this._buttons[i];
            button.tint = 0xFFFFFF;
        }
        button.tint = 0xFF0000;
        this._currentFocus = button;
    }

    /**
     * @private
     */
    _selectLeft() {
        console.log("left");
    }

    /**
     * @private
     */
    _selectRight() {
        console.log("right");
    }

    /**
     * @private
     */
    _selectUp() {
        console.log("up");
    }

    /**
     * @private
     */
    _selectDown() {
        console.log("down");
    }
}